import React from "react";
import PropTypes from "prop-types";
import clsx from "clsx";

function Spinner({ color = "primary500", size = "md", className }) {
  const classes = clsx(
    "inline-block animate-spin rounded-full border-4 border-solid",
    {
      md: "size-10",
      lg: "size-24",
      sm: "size-4 border-2",
    }[size],
    {
      error600: "border-error600 border-t-transparent",
      primary500: "border-primary500 border-t-transparent",
      success500: "border-success500 border-t-transparent",
      warning500: "border-warning500 border-t-transparent",
      white: "border-white border-t-transparent",
    }[color],
    className
  );
  return <div className={classes} />;
}

export default Spinner;
